import { writable } from "svelte/store";

import type { Product } from "@shared/types/ProductLine";

const defaultStoreState: { [key: number]: { products: Product[]; futurePrices?: [] } } = {};

export default writable(defaultStoreState);
